<template>
<div class="chapter">
<div class="inner_page">
<p class="fmtitle"><a id="page_v"></a>CONTENTS</p>
<table cellpadding="0" cellspacing="0" width="100%">
<colgroup><col width="20%"/>
<col width="80%"/>
</colgroup><tbody><tr>
<td valign="top"></td>
<td valign="top">
<p class="toc"><a href="#/Text/06_Acknowledgement"><i>Acknowledgments</i></a></p>
</td>
</tr>
<tr>
<td valign="top"></td>
<td valign="top">
<p class="toca"><a href="#/Text/07_Introduction">Introduction</a></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="tocs"><a href="#/Text/08_Chapter01"><span class="small">CHAPTER 1</span>.</a></p>
</td>
<td valign="top">
<p class="toc"><a href="#/Text/08_Chapter01">George Woodward Morse</a></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="tocs"><a href="#/Text/09_Chapter02"><span class="small">CHAPTER 2</span>.</a></p>
</td>
<td valign="top">
<p class="toc"><a href="#/Text/09_Chapter02">Morse’s Early Patents</a></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="tocs"><a href="#/Text/10_Chapter03"><span class="small">CHAPTER 3</span>.</a></p>
</td>
<td valign="top">
<p class="toc"><a href="#/Text/10_Chapter03">Nathan M. Muzzy</a></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="tocs"><span href="#/Text/11_Chapter04" title="Link target outside of Sample"><span class="small">CHAPTER 4</span>.</span></p>
</td>
<td valign="top">
<p class="toc"><span href="#/Text/11_Chapter04" title="Link target outside of Sample">War Department Evaluations, 1857–1858</span></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="tocs"><span href="#/Text/12_Chapter05" title="Link target outside of Sample"><span class="small">CHAPTER 5</span>.</span></p>
</td>
<td valign="top">
<p class="toc"><span href="#/Text/12_Chapter05" title="Link target outside of Sample">Springfield Armory</span></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="tocs"><span href="#/Text/13_Chapter06" title="Link target outside of Sample"><span class="small">CHAPTER 6</span>.</span></p>
</td>
<td valign="top">
<p class="toc"><span href="#/Text/13_Chapter06" title="Link target outside of Sample">Morse’s New Carbine, 1860</span></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="tocs"><span href="#/Text/14_Chapter07" title="Link target outside of Sample"><span class="small">CHAPTER 7</span>.</span></p>
</td>
<td valign="top">
<p class="toc"><span href="#/Text/14_Chapter07" title="Link target outside of Sample">Morse in Late 1860 and Early 1861</span></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="tocs"><span href="#/Text/15_Chapter08" title="Link target outside of Sample"><span class="small">CHAPTER 8</span>.</span></p>
</td>
<td valign="top">
<p class="toc"><span href="#/Text/15_Chapter08" title="Link target outside of Sample">Harpers Ferry, Nashville, and Atlanta</span></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="tocs"><span href="#/Text/16_Chapter09" title="Link target outside of Sample"><span class="small">CHAPTER 9</span>.</span></p>
</td>
<td valign="top">
<p class="toc"><span href="#/Text/16_Chapter09" title="Link target outside of Sample">South Carolina State Military Works and David Lopez Jr.</span></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="tocs"><span href="#/Text/17_Chapter10" title="Link target outside of Sample"><span class="small">CHAPTER 10</span>.</span></p>
</td>
<td valign="top">
<p class="toc"><span href="#/Text/17_Chapter10" title="Link target outside of Sample">1862</span></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="tocs"><span href="#/Text/18_Chapter11" title="Link target outside of Sample"><span class="small">CHAPTER 11</span>.</span></p>
</td>
<td valign="top">
<p class="toc"><span href="#/Text/18_Chapter11" title="Link target outside of Sample">Morse Comes to South Carolina</span></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="tocs"><span href="#/Text/19_Chapter12" title="Link target outside of Sample"><span class="small">CHAPTER 12</span>.</span></p>
</td>
<td valign="top">
<p class="toc"><span href="#/Text/19_Chapter12" title="Link target outside of Sample">Labor</span></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="tocs"><span href="#/Text/20_Chapter13" title="Link target outside of Sample"><span class="small">CHAPTER 13</span>.</span></p>
</td>
<td valign="top">
<p class="toc"><span href="#/Text/20_Chapter13" title="Link target outside of Sample">1863</span></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="tocs"><span href="#/Text/21_Chapter14" title="Link target outside of Sample"><span class="small">CHAPTER 14</span>.</span></p>
</td>
<td valign="top">
<p class="toc"><span href="#/Text/21_Chapter14" title="Link target outside of Sample">Lopez’s Resignation and Successor</span></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="tocs"><span href="#/Text/22_Chapter15" title="Link target outside of Sample"><span class="small">CHAPTER 15</span>.</span></p>
</td>
<td valign="top">
<p class="toc"><span href="#/Text/22_Chapter15" title="Link target outside of Sample">Morse’s Brass-frame Carbine</span></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="tocs"><span href="#/Text/23_Chapter16" title="Link target outside of Sample"><span class="small">CHAPTER 16</span>.</span></p>
</td>
<td valign="top">
<p class="toc"><span href="#/Text/23_Chapter16" title="Link target outside of Sample">Sale of the State Works</span></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="tocs"><span href="#/Text/24_Chapter17" title="Link target outside of Sample"><span class="small">CHAPTER 17</span>.</span></p>
</td>
<td valign="top">
<p class="toc"><span href="#/Text/24_Chapter17" title="Link target outside of Sample">Late 1863 and 1864</span></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="tocs"><span href="#/Text/25_Chapter18" title="Link target outside of Sample"><span class="small">CHAPTER 18</span>.</span></p>
</td>
<td valign="top">
<p class="toc"><span href="#/Text/25_Chapter18" title="Link target outside of Sample">1865</span></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="tocs"><span href="#/Text/26_Chapter19" title="Link target outside of Sample"><span class="small">CHAPTER 19</span>.</span></p>
</td>
<td valign="top">
<p class="toc"><span href="#/Text/26_Chapter19" title="Link target outside of Sample">State Military Works and Lopez, Postwar</span></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="tocs"><span href="#/Text/27_Chapter20" title="Link target outside of Sample"><span class="small">CHAPTER 20</span>.</span></p>
</td>
<td valign="top">
<p class="toc"><span href="#/Text/27_Chapter20" title="Link target outside of Sample">Morse’s Postwar Patent Petitions and Lawsuits</span></p>
</td>
</tr>
<tr>
<td valign="top">
<p class="tocs"><span href="#/Text/28_Chapter21" title="Link target outside of Sample"><span class="small">CHAPTER 21</span>.</span></p>
</td>
<td valign="top">
<p class="toc"><span href="#/Text/28_Chapter21" title="Link target outside of Sample">Morse’s Final Productivity</span></p>
</td>
</tr>
<tr>
<td valign="top"></td>
<td valign="top">
<p class="toc"><span href="#/Text/29_Conclusion" title="Link target outside of Sample">Conclusion</span></p>
</td>
</tr>
<tr>
<td valign="top"></td>
<td valign="top">
<p class="toc1t"><span href="#/Text/30_Appendix01" title="Link target outside of Sample"><i>Appendix 1</i>. Inventory of Machinery, Tools, and Stock of Tennessee Armory, Atlanta, March 1862</span></p>
</td>
</tr>
<tr>
<td valign="top"></td>
<td valign="top">
<p class="toc1"><span href="#/Text/31_Appendix02" title="Link target outside of Sample"><i>Appendix 2</i>. Surviving Morse Firearms Listed by Serial Number</span></p>
</td>
</tr>
<tr>
<td valign="top"></td>
<td valign="top">
<p class="toc1"><span href="#/Text/32_Appendix03" title="Link target outside of Sample"><i>Appendix 3</i>. List of Slave Workers</span></p>
</td>
</tr>
<tr>
<td valign="top"></td>
<td valign="top">
<p class="toc1"><a id="page_vi"></a><span href="#/Text/33_Appendix04" title="Link target outside of Sample"><i>Appendix 4</i>. List of White Employees</span></p>
</td>
</tr>
<tr>
<td valign="top"></td>
<td valign="top">
<p class="toc1"><span href="#/Text/34_Appendix05" title="Link target outside of Sample"><i>Appendix 5</i>. Total Production of Morse’s Firearms</span></p>
</td>
</tr>
<tr>
<td valign="top"></td>
<td valign="top">
<p class="toc1"><span href="#/Text/35_Notes" title="Link target outside of Sample"><i>Notes</i></span></p>
</td>
</tr>
<tr>
<td valign="top"></td>
<td valign="top">
<p class="toc1"><span href="#/Text/36_Bibliography" title="Link target outside of Sample"><i>Bibliography</i></span></p>
</td>
</tr>
<tr>
<td valign="top"></td>
<td valign="top">
<p class="toc1"><span href="#/Text/37_Index01" title="Link target outside of Sample"><i>Index</i></span></p>
</td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Contents.vue?74ff8d59